"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockListResponseToJSON = exports.BlockListResponseFromJSONTyped = exports.BlockListResponseFromJSON = void 0;
const _1 = require("./");
function BlockListResponseFromJSON(json) {
    return BlockListResponseFromJSONTyped(json, false);
}
exports.BlockListResponseFromJSON = BlockListResponseFromJSON;
function BlockListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'],
        'results': (json['results'].map(_1.BlockFromJSON)),
    };
}
exports.BlockListResponseFromJSONTyped = BlockListResponseFromJSONTyped;
function BlockListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'total': value.total,
        'results': (value.results.map(_1.BlockToJSON)),
    };
}
exports.BlockListResponseToJSON = BlockListResponseToJSON;
//# sourceMappingURL=BlockListResponse.js.map